import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import so from '@constants/locales/so.json';
import en from '@constants/locales/en.json';
import ar from '@constants/locales/ar.json';
import fr from '@constants/locales/fr.json';
import pt from '@constants/locales/pt.json';
import am from '@constants/locales/am.json';
import ur from '@constants/locales/ur.json';
import sw from '@constants/locales/sw.json';
import config from '@config/index';
import { langFromIso } from '@utils/index';

export function getTranslationConfig(language) {
  i18n.use(initReactI18next).init({
    lng: language,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      so: {
        translation: so,
      },
      en: {
        translation: en,
      },
      ar: {
        translation: ar,
      },
      fr: {
        translation: fr,
      },
      pt: {
        translation: pt,
      },
      am: {
        translation: am,
      },
      ur: {
        translation: ur,
      },
      sw: {
        translation: sw,
      },
    },
  });

  return i18n;
}

export const i18nInstance = getTranslationConfig(langFromIso(config.language));
